import type { CodingScheme, ProcessArea } from './types';

// Presentación de la codificación de documentos (G3-2, 04-GC-P08 §B.1). Puro: textos de
// los tipos de proceso (01 a 04) y de los esquemas, tipo heredado de un subproceso y
// procesos principales que aún no tienen tipo (sin él no se propone el código).

export const PROCESS_TYPES: readonly { value: number; label: string }[] = [
  { value: 1, label: '01 Estratégicos' },
  { value: 2, label: '02 Operativos' },
  { value: 3, label: '03 Apoyo' },
  { value: 4, label: '04 Control y Mejora' },
];

export function processTypeLabel(value: number | null): string | null {
  return PROCESS_TYPES.find((t) => t.value === value)?.label ?? null;
}

/** Tipo de proceso efectivo: el del proceso principal del que cuelga. Un ciclo → null. */
export function effectiveProcessType(
  area: ProcessArea,
  areas: readonly ProcessArea[],
): number | null {
  const byId = new Map(areas.map((a) => [a.id, a]));
  const seen = new Set<string>();
  let current: ProcessArea | undefined = area;
  while (current !== undefined) {
    if (seen.has(current.id)) {
      return null;
    }
    seen.add(current.id);
    if (current.parentId === null) {
      return current.processType;
    }
    current = byId.get(current.parentId);
  }
  return null;
}

/** Proceso principal del que cuelga un subproceso (para "Lo hereda de…"). */
export function rootOf(area: ProcessArea, areas: readonly ProcessArea[]): ProcessArea | null {
  const byId = new Map(areas.map((a) => [a.id, a]));
  const seen = new Set<string>();
  let current: ProcessArea | undefined = area;
  while (current !== undefined && !seen.has(current.id)) {
    seen.add(current.id);
    if (current.parentId === null) {
      return current;
    }
    current = byId.get(current.parentId);
  }
  return null;
}

/** Procesos principales activos sin tipo de proceso configurado. */
export function rootsWithoutType(areas: readonly ProcessArea[]): ProcessArea[] {
  return areas.filter((a) => a.parentId === null && a.isActive && a.processType === null);
}

export const CODING_SCHEMES: readonly { value: CodingScheme; label: string; hint: string }[] = [
  {
    value: 'proceso',
    label: 'Según el proceso',
    hint: 'Tipo de proceso, siglas del proceso, siglas del tipo y consecutivo: 04-GC-P08.',
  },
  {
    value: 'sap',
    label: 'Registro SAP',
    hint: 'SAP, módulo y consecutivo de 4 dígitos: SAP-IN-0001.',
  },
  {
    value: 'libre',
    label: 'Libre (sin patrón)',
    hint: 'Calidad escribe el código de cada documento.',
  },
];

export function codingSchemeLabel(value: CodingScheme): string {
  return CODING_SCHEMES.find((s) => s.value === value)?.label ?? value;
}
